import React from 'react'
import styled from 'styled-components'
import { Icon } from 'rsuite'

export default function Tip ({ type, text }) {
  var icon
  var spanishType

  switch(type){
    case 'Plane': 
      icon = 'plane'
      spanishType = 'Avión'
      break
    case 'Bus': 
      icon = 'bus'
      spanishType = 'Bus de Acercamiento'
      break
    case 'Ship': 
      icon = 'ship'
      spanishType = 'Barco'
      break
    case 'Help': 
      icon = 'info'
      spanishType = 'Información'
      break
    case 'Microbus': 
      icon = 'bus'
      spanishType = 'Micro'
      break
    case 'Taxi': 
      icon = 'cab'
      spanishType = 'Taxi'
      break
    case 'Metro': 
      icon = 'subway'
      spanishType = 'Metro'
      break
    case 'Transfer': 
      icon = 'car'
      spanishType = 'Transfer'
      break
  }
  
  return (
    <Container>
      <Content>
        <Title>
          <StyledIcon icon={icon} size='1x'/>
          <Type>{spanishType}</Type>
        </Title>

        <Text>
          - {text}
        </Text>
      </Content>
    </Container>
  )
}

const Container = styled.div`
  flex-direction: row;
  margin-top: 24px;
`
const StyledIcon = styled(Icon)`
  margin: 7px 10px 0 15px;
  width: 10px;
`

const Content = styled.div`
  width: 100%;
  flex: 1;
`

const Type = styled.p`
  font-weight: 800;
`
const Title = styled.div`
  display: flex;
  flex-direction: row;
`

const Text = styled.p`
  margin-left: 15px;
`
